export const menuTitle = { title: "TAX TYPE", label: "Tax Type" }
  